var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77952 1.25H0.220486C0.0987152 1.25 0 1.34871 0 1.47049V1.96701C0 2.08879 0.0987152 2.1875 0.220486 2.1875H9.77952C9.90129 2.1875 10 2.08879 10 1.96701V1.47049C10 1.34871 9.90129 1.25 9.77952 1.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77952 7.8125H0.220486C0.0987152 7.8125 0 7.91122 0 8.03299V8.52951C0 8.65128 0.0987152 8.75 0.220486 8.75H9.77952C9.90129 8.75 10 8.65128 10 8.52951V8.03299C10 7.91122 9.90129 7.8125 9.77952 7.8125Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88264 2.8125H3.11736C2.94899 2.8125 2.8125 2.94899 2.8125 3.11736V6.88264C2.8125 7.05101 2.94899 7.1875 3.11736 7.1875H6.88264C7.05101 7.1875 7.1875 7.05101 7.1875 6.88264V3.11736C7.1875 2.94899 7.05101 2.8125 6.88264 2.8125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterIcon);
export default __webpack_public_path__ + "static/media/AlignCenterIcon.cb383bc8672c3828b8bb8b6761da2998.svg";
export { ForwardRef as ReactComponent };